module.exports = "/packs/003-05e8dd6729469a8f834444d143c1d320.jpg";